import React from 'react';
import Burger from './Burger';
import MenuCustom from './Menu/MenuCustom';


const useOnClickOutside = (ref, handler) => {
  React.useEffect(() => {
      const listener = event => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener('mousedown', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
      };
    },
    [ref, handler],
  );
};

function HamburgerCustom(props) {
  const [open, setOpen] = React.useState(false);
  const node = React.useRef();
  const menuId = 'main-menu';
  useOnClickOutside(node, () => setOpen(false));

  const styleOverlay = {
    position: 'fixed',
    zIndex: 1000,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
    opacity: 1,
    transition: 'opacity 0.3s ease 0s',
    maxWidth: 560,
  };

  return (
    <div className='iframe-pre-hidden-top-menu'>
      {open && (<div className="bm-overlay" style={styleOverlay}></div>)}
      <div ref={node} className="d-box-hamburger">
        <Burger className={`d-burger ${open ? 'd-burger-expand' : 'd-burger-close'}`} open={open} setOpen={setOpen} aria-controls={menuId} />
        <MenuCustom open={open} setOpen={setOpen} {...props} />
      </div>
    </div>
  );
};

export default HamburgerCustom;
